import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Col, Form, FormControl, Row } from 'react-bootstrap';

const EditFolioExt = ({ currentFolioExt, saveFolioExt, closeModal }) => {
  const [folioExt, setFolioExt] = useState(currentFolioExt);
  return (
    <Card style={{ width: '100%' }}>
      <Card.Body>
        <Row>
          <Col>
            <Form.Group className="mb-4">
              <Form.Label>Folio Externo</Form.Label>
              <FormControl
                onChange={e => setFolioExt(e.target.value)}
                type="text"
                defaultValue={folioExt}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col>
            <Button
              type="button"
              color="primary"
              size="sm"
              onClick={() => {
                saveFolioExt(folioExt);
                closeModal();
              }}
            >
              Guardar
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

EditFolioExt.propTypes = {
  idQueja: PropTypes.string.isRequired,
  closeModal: PropTypes.func,
  currentFolioExt: PropTypes.string,
  saveFolioExt: PropTypes.func
};

export default EditFolioExt;
